import { render, staticRenderFns } from "./cam_dummy.vue?vue&type=template&id=4ef1873a"
import script from "./cam_dummy.vue?vue&type=script&lang=js"
export * from "./cam_dummy.vue?vue&type=script&lang=js"
import style0 from "./cam_dummy.vue?vue&type=style&index=0&id=4ef1873a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports